import React, { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import { hasRolloutFeature, ROLLOUT_FEATURES } from "../../utils/rolloutFeatures";
import LegacyComponent from "./Legacy";
import RolloutComponent from "./Rollout";

const FlowBuilderAddOpenAIModal = props => {
  const { user } = useContext(AuthContext);
  const Component = hasRolloutFeature(user, ROLLOUT_FEATURES.AI)
    ? RolloutComponent
    : LegacyComponent;
  return <Component {...props} />;
};

export default FlowBuilderAddOpenAIModal;
